module.exports = __webpack_public_path__ + "static/media/Screenshot9.29b41299.png";